export default "__VITE_ASSET__D1NH8BJl__"